import { catchErrorLogin } from '../../utils/CatchErrorLogin/CatchErrorLogin'
import { apiService } from '../_config_/apiservice'

export const AuthLogin = async (login: string, password: string) => {
  try {
    const result = await apiService.post('/central/autenticacao/login', {
      email: login.trim(),
      senha: password,
    })
    if (result.status === 200) {
      apiService.defaults.headers.common.Authorization = `${result.data.type} ${result.data.token}`
      localStorage.setItem('token', JSON.stringify(result.data))
      return { logged: true, message: 'Login bem sucedido' }
    }
  } catch (error) {
    return catchErrorLogin(error)
  }

  return {
    logged: false,
    message: 'Algo de errado aconteceu!',
  }
}
